import { gql } from '@apollo/client';
import { apolloClient } from '~/apollo-client';

export type PerchProductOption = {
  name: string;
  salesforceId: string;
};

const FETCH_PERCH_PRODUCTS_FOR_UTILITY_OR_STATE = gql`
  query Flex_FetchPerchProductsForUtilityOrState($utilityId: Int, $stateAbbreviation: String) {
    perchProductsForUtilityOrState(utilityId: $utilityId, stateAbbreviation: $stateAbbreviation) {
      name
      salesforceId
    }
  }
`;

export async function fetchPerchProductsForUtilityOrState(params: {
  utilityId?: number;
  stateAbbreviation?: string;
}): Promise<PerchProductOption[]> {
  const variables =
    params.utilityId != null && params.utilityId > 0
      ? { utilityId: params.utilityId, stateAbbreviation: undefined }
      : { utilityId: undefined, stateAbbreviation: params.stateAbbreviation };

  const { data } = await apolloClient.query<{
    perchProductsForUtilityOrState: PerchProductOption[];
  }>({
    query: FETCH_PERCH_PRODUCTS_FOR_UTILITY_OR_STATE,
    variables,
    fetchPolicy: 'network-only',
  });

  return data?.perchProductsForUtilityOrState ?? [];
}
